import { History, UserRoundPlus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { EmptyState } from "@/components/EmptyState";
import { Page } from "@/components/Page";
import { PageHeader } from "@/components/PageHeader";
import { consoleOperatorsPath, OPERATORS_TABS, type OperatorsTab } from "../router.tsx";
import { SettingsGroupTabs } from "../settings-shell/SettingsGroupTabs.tsx";
import { OperatorSessions } from "./OperatorSessions.tsx";

/**
 * Operators (proposal ui-refresh-auth-console): one page per tab. Sessions is today's operator
 * sessions; Operators and Activity are the slots of operator management (#238), stated as not
 * available yet, never with sample rows.
 */
export function OperatorsPage({ tab }: { tab: OperatorsTab }) {
  const { t } = useTranslation();
  return (
    <Page>
      <PageHeader title={t("console.operators.title")} lead={t("console.operators.lead")} />
      <SettingsGroupTabs
        label={t("console.operators.tabsLabel")}
        groups={OPERATORS_TABS}
        current={tab}
        href={consoleOperatorsPath}
        groupLabel={(g) => t(`console.operators.tabs.${g}`)}
        count={() => 0}
        countLabel={() => ""}
      />
      {tab === "sessions" ? <OperatorSessions /> : null}
      {tab === "members" ? (
        <EmptyState
          icon={UserRoundPlus}
          title={t("console.operators.membersTitle")}
          status={t("console.operators.notYet")}
        >
          {t("console.operators.membersBody")}
        </EmptyState>
      ) : null}
      {tab === "audit" ? (
        <EmptyState
          icon={History}
          title={t("console.operators.auditTitle")}
          status={t("console.operators.notYet")}
        >
          {t("console.operators.auditBody")}
        </EmptyState>
      ) : null}
    </Page>
  );
}
